<template>
  <div class="view-tasklists assessment-add-section">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu />
      <div id="top" class="content-wrapper">
        <div  class="container-wrapper center">
          <div class="modal-custom" v-show="showOverlay">
            <div class="loader-img-center">
              <i class="fa fa-spinner fa-spin"></i> Please wait...
            </div>
          </div>
          <div>
            <div class="">
              <h3 class="d-inline heading">Edit Notification</h3>
              <button class="d-inline btn btn-blue float-right create-btn ml-1" v-on:click="onSubmit">
                Save
              </button>
            </div>
          </div>
          <div class="heading-seperator"></div>
          <div style="clear: both"></div>

          <div class="margin-bottom-10"></div>

          <div class="">

          <div class="col-12 override-padding">

            <div class="col-12 override-padding">
                <div class="subtask-wrapper">
                  <h4 class="panel-title">
                      Notification Information
                  </h4>
                </div>
            </div>
            <div class="col-6 override-padding float-left" style="padding-left: 15px;">
              <div class="col-12 override-padding">
                <div class="col-3 override-padding float-left">
                  <label>Category: </label>
                </div>
                <div class="col-9 override-padding float-left">
                  <b-form-select
                    class="input-text col-12"
                    style="margin-right: 15px;"
                    name="notification_category_id"
                    v-model="notification_category_id"
                    v-validate="'required'"
                    :options="category_options">
                  </b-form-select>
                </div>
              </div>
              <div style="clear: both;" class="margin-bottom-10"></div>
              <div class="col-12 override-padding">
                <div class="col-3 override-padding float-left">
                  <label>Template Name: </label>
                </div>
                <div class="col-9 override-padding float-left">
                  <input v-model="notification_name"
                        name="notification_name"
                        placeholder="Enter Notification Template Name"
                        class="col-12 input-text form-control"
                        style="line-height: 30px; "
                        maxlength="140" />
                </div>
              </div>
              <div style="clear: both;" class="margin-bottom-10"></div>
              <div class="col-12 override-padding">
                <div class="col-3 override-padding float-left">
                  <label>Role: </label>
                </div>
                <div class="col-9 override-padding float-left" id="mentee-group-wrapper">
                  <multiselect
                    v-model="roles_selected"
                    :options="roles_options"
                    track-by="name" label="name"
                    placeholder="Select Notification Role"
                    :multiple="true" 
                    :close-on-select="false"
                    :show-labels="false"
                    name="roles_show"
                    id="roles_show"
                    >
                    <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
              

                  </multiselect>
                </div>
              </div>
              <div style="clear: both;" class="margin-bottom-10"></div>

            </div>

            <div class="col-6  float-left" >
              <div class="col-12 override-padding">
                <div class="col-3 override-padding float-left">
                  <label>Trigger Note: </label>
                </div>
                <div class="col-9 override-padding float-left">
                  <input v-model="trigger_note"
                        name="trigger_note"
                        placeholder="Enter Trigger Note"
                        class="col-12 input-text form-control"
                        style="line-height: 30px; "
                        maxlength="250" />
                  </b-form-select>
                </div>
              </div>
              <div style="clear: both;" class="margin-bottom-10"></div>
              <div class="col-12 override-padding">
                <div class="col-3 override-padding float-left">
                  <label>Purpose Note: </label>
                </div>
                <div class="col-9 override-padding float-left">
                  <textarea
                      name="purpose_note" 
                      v-model="purpose_note"
                      placeholder="Purpose Notes"
                      class="textarea col-xs-12 col-md-12 col-lg-12 input-height-25"
                      maxlength="500" style="height: 90px;">
                      </textarea>
                </div>
              </div>
              <div style="clear: both;"></div>
            </div>


          </div>
          <div style="clear: both;" class="margin-bottom-10"></div>
            <div class="col-12 override-padding">
                <div class="subtask-wrapper">
                  <h4 class="panel-title">
                    <b-link v-b-toggle="'collapse-1'" size="sm" class="">
                      Email Notification
                    </b-link>
                  </h4>
                  <b-collapse v-bind:id="'collapse-1'" class="mt-2 task-wrapper">
                    <b-card class="hidden-xs hidden-sm">
                      <div class="col-12 override-padding">
                        <div class="col-9 override-padding float-left" style="padding-left: 15px;">
                          <div class="col-12 override-padding" style="padding-top: 7px;">
                            <div class="col-2 override-padding float-left">
                              <label>Subject Line: </label>
                            </div>
                            <div class="col-10 override-padding float-left">
                              <input v-model="email_subject_line"
                                    name="email_subject_line"
                                    placeholder="Enter Subject Line"
                                    class="col-12 input-text form-control"
                                    style="line-height: 30px; "
                                    maxlength="250" />
                            </div>
                          </div>
                          <div style="clear: both; margin-bottom: 12px;"></div>
                          <div class="col-12 override-padding">
                            <div class="col-2 override-padding float-left">
                              <label>From: </label>
                            </div>
                            <div class="col-10 override-padding float-left">
                              <b-form-select
                                class="input-text col-12"
                                style="margin-right: 15px;"
                                name="email_from"
                                v-model="email_from"
                                :options="from_email_options">
                              </b-form-select>
                            </div>
                          </div>
                          <div style="clear: both; margin-bottom: 12px;"></div>
                          <div class="col-12 override-padding">
                            <div class="col-2 override-padding float-left">
                              <label>To: </label>
                            </div>
                            <div class="col-10 override-padding float-left">
                              <input v-model="email_to"
                                    name="email_to"
                                    id="email_to"
                                    placeholder="Enter To Address"
                                    class="col-12 input-text form-control"
                                    style="line-height: 30px; "
                                    maxlength="250" />
                            </div>
                          </div>
                          <div style="clear: both;" class="margin-bottom-10"></div>
                          <div class="col-12 override-padding">
                            <div class="col-2 override-padding float-left">
                              <label>Email Message: </label>
                            </div>
                            <div class="col-10 override-padding float-right" style="text-align: right;">
                              <label>Enabled: </label>
                              <label class="switch" style="margin-left: 10px; padding: 0;">
                                <input type="checkbox" v-model="email_status" >
                                <span class="slider round"></span>
                              </label>
                            </div>
                          </div>
                          <div style="clear: both; margin-bottom: 0px;" class=""></div>
                          <div class="col-12 override-padding email-message">

                            <vue-editor v-model="email_message" ref="textarea" placeholder="Enter Email Message" @text-change="emailMessageChange"></vue-editor>
                            <div class="character-limit">
                              <div class="col-6 float-left" style="text-align: left;">
                                
                              </div>
                              <div class="col-6 float-right"  style="text-align: right;">
                                Characters Remaining: {{ email_count }}
                              </div>
                              <div style="clear: both"></div>
                            </div>
                          </div>
                        </div>
                        <div class="col-3 float-left" >
                          <div class="col-12 override-padding">
                            <label style="padding: 0; line-height: 12px;">Select "To" Email: </label>
                          </div>
                          <div class="col-12 " style="background-color: #FFF; border: 1px  solid #242426; padding: 5px;">
                            <div class="" v-for="list in to_email_options">
                              <div class="" @click="inclToEmail(list)" style="cursor: pointer;">{{ list }}</div>
                            </div>
                          </div>


                          <div class="col-12 override-padding" style="padding-top: 12px;">
                            <label >Select fields: </label>
                          </div>
                          <div class="col-12 " style="background-color: #FFF; border: 1px  solid #242426; padding: 5px; margin-top: 1px; height: 350px; overflow: scroll;">
                            <div class="" v-for="list in field_options">
                              <div class="" @click="inclEmailMessage(list)" style="cursor: pointer;">{{ list }}</div>
                            </div>
                          </div>

                        </div>



                      </div>
                    </b-card>
                  </b-collapse>
                </div>
            </div>


            <div style="clear: both;" class="margin-bottom-10"></div>
            <div class="col-12 override-padding">
                <div class="subtask-wrapper">
                  <h4 class="panel-title">
                    <b-link v-b-toggle="'collapse-2'" size="sm" class="">
                      SMS Notification
                    </b-link>
                  </h4>
                  <b-collapse v-bind:id="'collapse-2'" class="mt-2 task-wrapper">
                    <b-card class="hidden-xs hidden-sm">
                      <div class="col-12 override-padding">
                        <div class="col-9 override-padding float-left" style="padding-left: 15px;">
                          <div class="col-12 override-padding">
                            <div class="col-2 override-padding float-left">
                              <label>SMS Message: </label>
                            </div>
                            <div class="col-10 override-padding float-right" style="text-align: right;">
                              <label>Enabled: </label>
                              <label class="switch" style="margin-left: 10px; padding: 0;">
                                <input type="checkbox" v-model="sms_status" >
                                <span class="slider round"></span>
                              </label>
                            </div>
                          </div>
                          <div style="clear: both; margin-bottom: 0px;" class=""></div>
                          <div class="col-12 override-padding">
                            <textarea
                                name="sms_message"
                                id="sms_message" 
                                v-model="sms_message"
                                placeholder="Enter SMS Message"
                                class="textarea col-xs-12 col-md-12 col-lg-12 input-height-25" style="height: 320px;" v-on:keyup="smsMessageChange" 
                                :maxlength="sms_limit">
                                </textarea>
                            <div class="character-limit" style="margin-top: -7px;">
                              <div class="col-6 float-left" style="text-align: left;">
                                Characters Limit: {{ sms_limit }}
                              </div>
                              <div class="col-6 float-right"  style="text-align: right;">
                                Characters Remaining: {{ sms_count }}
                              </div>
                              <div style="clear: both"></div>
                            </div>
                          </div>
                        </div>
                        <div class="col-3 float-left" >
                          <div class="col-12 override-padding" style="padding-top: 0px;">
                            <label >Select fields: </label>
                          </div>
                          <div class="col-12 " style="background-color: #FFF; border: 1px  solid #242426; padding: 5px; margin-top: 1px; height: 350px; overflow: scroll;">
                            <div class="" v-for="list in field_options">
                              <div class="" @click="inclSMSMessage(list)" style="cursor: pointer;">{{ list }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card>
                  </b-collapse>
                </div>
            </div>


            <div style="clear: both;" class="margin-bottom-10"></div>
            <div class="col-12 override-padding">
                <div class="subtask-wrapper">
                  <h4 class="panel-title">
                    <b-link v-b-toggle="'collapse-3'" size="sm" class="">
                      Push Notification
                    </b-link>
                  </h4>
                  <b-collapse v-bind:id="'collapse-3'" class="mt-2 task-wrapper">
                    <b-card class="hidden-xs hidden-sm">
                      <div class="col-12 override-padding">
                        <div class="col-9 override-padding float-left" style="padding-left: 15px;">
                          <div class="col-12 override-padding">
                            <div class="col-2 override-padding float-left">
                              <label>Push Title: </label>
                            </div>
                            <div class="col-10 override-padding float-right" style="text-align: right;">
                              <label>Enabled: </label>
                              <label class="switch" style="margin-left: 10px; padding: 0;">
                                <input type="checkbox" v-model="push_status" >
                                <span class="slider round"></span>
                              </label>
                            </div>
                          </div>
                          <div style="clear: both; margin-bottom: 0px;" class=""></div>
                          <div class="col-12 override-padding">
                            <textarea
                                name="push_title" 
                                v-model="push_title"
                                placeholder="Enter Push Title"
                                class="textarea col-xs-12 col-md-12 col-lg-12 input-height-25" style="height: 70px;"
                                :maxlength="push_title_limit" v-on:keyup="pushTitleChange" >
                                </textarea>
                            <div class="character-limit" style="margin-top: -7px;">
                              <div class="col-6 float-left" style="text-align: left;">
                                Characters Limit: {{ push_title_limit }}
                              </div>
                              <div class="col-6 float-right"  style="text-align: right;">
                                Characters Remaining: {{ push_title_count }}
                              </div>
                              <div style="clear: both"></div>
                            </div>
                          </div>

                          <div class="col-12 override-padding" style="padding-top: 10px;">
                            <div class="col-2 override-padding float-left">
                              <label>Push Message: </label>
                            </div>
                            <div class="col-10 override-padding float-right" style="text-align: right;">
                            </div>
                          </div>
                          <div style="clear: both; margin-bottom: 0px;" class=""></div>
                          <div class="col-12 override-padding">
                            <textarea
                                name="push_message" 
                                id="push_message"
                                v-model="push_message"
                                placeholder="Enter Push Message"
                                class="textarea col-xs-12 col-md-12 col-lg-12 input-height-25" style="height: 174px;"
                                :maxlength="push_limit" v-on:keyup="pushMessageChange" >
                                </textarea>
                            <div class="character-limit" style="margin-top: -7px;">
                              <div class="col-6 float-left" style="text-align: left;">
                                Characters Limit: {{ push_limit }}
                              </div>
                              <div class="col-6 float-right"  style="text-align: right;">
                                Characters Remaining: {{ push_count }}
                              </div>
                              <div style="clear: both"></div>
                            </div>
                          </div>

                        </div>
                        <div class="col-3 float-left" >
                          <div class="col-12 override-padding" style="padding-top: 0px;">
                            <label >Select fields: </label>
                          </div>
                          <div class="col-12 " style="background-color: #FFF; border: 1px  solid #242426; padding: 5px; margin-top: 1px; height: 350px; overflow: scroll;">
                            <div class="" v-for="list in field_options">
                              <div class="" @click="inclPushMessage(list)" style="cursor: pointer;">{{ list }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card>
                  </b-collapse>
                </div>
            </div>





          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import VeeValidate from 'vee-validate';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Multiselect from 'vue-multiselect';
import { VueEditor } from "vue2-editor";

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
        data() {
          return {
            showOverlay: false,
            masterAdmin: false,
            admin: false,
            category_options: [],
            notification_category_id: '',
            notification_name: '',
            roles_selected: [],
            trigger_note: '',
            purpose_note: '',
            email_subject_line: '',
            email_from: '',
            email_to: '',
            email_message: '',
            email_status: false,
            email_count: 2500,
            email_limit: 2500,
            sms_message: '',
            sms_status: false,
            sms_count: 500,
            sms_limit: 500,
            push_title: '',
            push_message: '',
            push_status: false,
            push_title_count: 65,
            push_title_limit: 65,
            push_count: 500,
            push_limit: 500,
            roles_options: [
              {
                name: 'Admin',
                value: 'ROLE_ADMIN',
              },
              {
                name: 'Mentor',
                value: 'ROLE_MENTOR',
              },
              {
                name: 'Mentee',
                value: 'ROLE_MENTEE',
              },
              {
                name: 'Apprentice',
                value: 'ROLE_APPRENTICE',
              },
              {
                name: 'Instructor',
                value: 'ROLE_INSTRUCTOR',
              },
            ],
            from_email_options: [
              {
                'value': '',
                'text': 'Select From Address',
              },
              {
                'value': 'info@mentormentee.com',
                'text': 'info@mentormentee.com',
              },
              {
                'value': 'sales@mentormentee.com',
                'text': 'sales@mentormentee.com',
              },
              {
                'value': 'support@mentormentee.com',
                'text': 'support@mentormentee.com',
              }
            ],
            to_email_options: [
              '{Primary Admin Email}',
              '{Manager Email}',
              '{Mentor Email}',
              '{Mentee Email}',
              '{Apprentice Email}',
              '{User Email}',
              '{Enterprise Admin Email}',
            ],
            field_options: [
              '{Location Name}',
              '{User Email}',
              '{Enterprise Admin First Name}',
              '{Enterprise Admin Last Name}',
              '{Enterprise User First Name}',
              '{Enterprise User Last Name}',
              '{Primary Account Admin First Name}',
              '{Primary Account Admin Last Name}',
              '{Billing Admin First Name}',
              '{Billing Admin Last Name}',
              '{Manager First Name}',
              '{Manager Last Name}',
              '{Mentor First Name}',
              '{Mentor Last Name}',
              '{Mentee/Apprentice First Name}',
              '{Mentee/Apprentice Last Name}',
              '{Manager First and Last Name}',
              '{Mentor First and Last Name}',
              '{Mentee/Apprentice First and Last Name}',
              '{Assessment Name}',
              '{Course Name}',
              '{Task List Name}',
              '{Date Course Completed}',
              '{Date Assessment Completed}',
              '{Task Goal Group Due Date}',
              '{# of Reps Submitted}',
              '{# of Reps to be Reviewed}',
              '{# of Tasks Hours Recorded}',
              '{Contact Us Checkbox fields}',
              '{Name of Most Commonly Used Task List}',
              '{First and Last Name of Mentee or Apprentice With Most Recorded Reps During Month}',
              '{Total # of Task Goal Groups Completed}',
              '{Total # of Mentee/Apprentice Competencies Earned}',
              '{# of New Locations Added}',
              '{# Reps Recorded for All Mentees/Apprentices During Week}',
              '{# of Task Goal Groups Completed}',
              '{Total Hours and Minutes Recorded by Mentees/Apprentices During Week}',
              '{Selected Contact Us Boxes Text}',
              '{Account Name}',
              '{Days}',
              '{# of Days Ahead of Task Goal Group Due Date}',
              '{# of Days Behind Task Goal Group Due Date}',
              '{Task Name, Sub-section Name, or Section Name}',
              '{User First Name}',
              '{Reset Link}',
              '{Confirmation Link}',
              '{Date of Oldest Submitted Rep}',
              '{Primary Enterprise Admin First Name}',
              '{# of Licenses Purchased}',
              '{# of Licenses Invoiced}',
              '{link}',
              '{# of Active Enterprise Locations}',
              '{First and Last Name of Mentee or Apprentice with Most Recorded Reps During Week}',
              '{Task Goal}',
              '{Name of Enterprise Account}',
              '{# of assigned licenses}',
            ],
          }
        },

        components: {
          UserMenu,
          GoBack,
          MasteradminSidebarMenu,
          DatePicker,
          Multiselect,
          VueEditor
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
            inclEmailMessage: function(arg) {
              let quill = this.$refs.textarea.quill;
              let pos = quill.selection.savedRange.index;
              
              const insertText = arg;

              if (pos === undefined) {
                pos = 0
              }
              quill.insertText(pos, insertText);

            },
            inclToEmail: function(arg) {
              var pos = document.getElementById('email_to').selectionStart;
              if (pos === undefined) {
                pos = 0
              }
              var val = this.email_to;
              if(val) {
                var new_val = val.slice(0,pos) + arg + val.slice(pos);
              }
              else {
                var new_val = arg;
              }
              
              if(new_val.length > 250) {
                new_val = val;
                alert("Maximum character limit exceeded.")
              }
              this.email_to = new_val;
            },
            inclSMSMessage: function(arg) {
              var pos = document.getElementById('sms_message').selectionStart;
              if (pos === undefined) {
                pos = 0
              }
              var val = this.sms_message;
              if(val) {
                var new_val = val.slice(0,pos) + arg + val.slice(pos);
              }
              else {
                var new_val = arg; 
              }
              if(new_val.length > 500) {
                new_val = val;
                alert("Maximum character limit exceeded.")
              }
              this.sms_message = new_val;
              this.smsMessageChange();
            },
            inclPushMessage: function(arg) {
              var pos = document.getElementById('push_message').selectionStart;
              if (pos === undefined) {
                pos = 0;
              }
              var val = this.push_message;
              if(val) {
                var new_val = val.slice(0,pos) + arg + val.slice(pos);
              }
              else {
                var new_val = arg;
              }
              if(new_val.length > 500) {
                new_val = val;
                alert("Maximum character limit exceeded.")
              }
              this.push_message = new_val;
              this.pushMessageChange();
            },
            smsMessageChange: function() {
              var limit = this.sms_limit;
              this.sms_count = parseInt(limit - this.sms_message.length);
            },
            pushTitleChange: function() {
              var limit = this.push_title_limit;
              this.push_title_count = parseInt(limit - this.push_title.length);
            },
            pushMessageChange: function() {
              var limit = this.push_limit;
              this.push_count = parseInt(limit - this.push_message.length);
            },
            emailMessageChange: function() {
              var limit = this.email_limit;
              var quill = this.$refs.textarea.quill;

              quill.on('text-change', function (delta, old, source) {
               var quill_length = parseInt(quill.getLength() - 1);
               if (quill_length > limit) {
                quill.deleteText(limit, quill.getLength());
               }
              });
              this.email_count = parseInt(limit - (quill.getLength() - 1));
              if(this.email_message == '') {
                this.email_count = this.email_limit;
              }
            },
            fetchCategoryOptions: function() {
              this.category_options = [];
             axios.get('/search-notification-category-options', {

             })
             .then((response) => {
                 var category_option = {value: '', text: 'Select Category'};
                 this.category_options.push(category_option);
                 for(var i=0; i < response.data.length; i++) {
                   var name = response.data[i].categoryName;
                   var category_option = {value: response.data[i].id, text: name};
                   this.category_options.push(category_option);
                 }
             })
             .catch(error => {

             });
            },
            doValidate: function() {
              var vflag = 1;
              if(!this.notification_name) {
                alert("Please enter Notification Template Name");
                vflag = 0;
                return false;
              }
              if(this.notification_category_id == '') {
                alert("Please select Notification Category");
                vflag = 0;
                return false;
              }
              if(this.email_status == true) {
                if(!this.email_subject_line) {
                  alert("Please Enter Email Subject Line");
                  vflag = 0;
                  return false;
                }
                if(this.email_from == '') {
                  alert("Please Select Email From Address");
                  vflag = 0;
                  return false;
                }
                if(!this.email_to) {
                  alert("Please Enter Email To Address");
                  vflag = 0;
                  return false;
                }
                if(!this.email_message) {
                  alert("Please Enter Email Message");
                  vflag = 0;
                  return false;
                }
              }
              if(this.sms_status == true) {
                if(!this.sms_message) {
                  alert("Please Enter SMS Message");
                  vflag = 0;
                  return false;
                }
              }
              if(this.push_status == true) {
                if(!this.push_title) {
                  alert("Please Enter Push Title");
                  vflag = 0;
                  return false;
                }
                if(!this.push_message) {
                  alert("Please Enter Push Message");
                  vflag = 0;
                  return false;
                }
              }
              return vflag;
            },            
            onSubmit: function() {
              var vflag = this.doValidate();
              if(vflag == 1) {
                axios('/notification-manager-details/' + this.notificationId,
                   {
                     method: 'POST',
                     data: {
                        "notification_name": this.notification_name,
                        "notification_category_id": this.notification_category_id,
                        "roles_selected": this.roles_selected,
                        "trigger_note": this.trigger_note,
                        "purpose_note": this.purpose_note,
                        "email_subject_line": this.email_subject_line,
                        "email_from": this.email_from,
                        "email_to": this.email_to,
                        "email_message": this.email_message,
                        "email_status": this.email_status,
                        "sms_message": this.sms_message,
                        "sms_status": this.sms_status,
                        "push_title": this.push_title,
                        "push_message": this.push_message,
                        "push_status": this.push_status,
                     },
                   })
                .then((resp) => {
                    router.push('/notification-manager-list');
                 })
                .catch(error => {

                });
              }

            },

            fetchNotificationDetails: function() {
              this.loading = true;
              axios.get('/notification-manager-details/' + this.notificationId)
                .then((resp) => {
                  this.notification_name = resp.data.notification[0].templateName;
                  this.notification_category_id = resp.data.notification[0].category_id;
                  this.roles_selected = resp.data.notification[0].notification_roles;
                  this.trigger_note = resp.data.notification[0].triggerNote;
                  this.purpose_note = resp.data.notification[0].purposeNote;
                  this.email_subject_line = resp.data.notification[0].emailSubject;
                  this.email_from = resp.data.notification[0].emailFrom;
                  if(!this.email_from) {
                    this.email_from = '';
                  }
                  this.email_to = resp.data.notification[0].emailTo;
                  this.email_message = resp.data.notification[0].emailMessage;
                  this.email_status = resp.data.notification[0].emailFlag;
                  this.sms_message = resp.data.notification[0].smsMessage;
                  this.sms_status = resp.data.notification[0].smsFlag;
                  this.push_title = resp.data.notification[0].pushTitle;
                  this.push_message = resp.data.notification[0].pushMessage;
                  this.push_status = resp.data.notification[0].pushFlag;
                  this.smsMessageChange()
                  //this.pushTitleChange();
                  this.pushMessageChange();
                })
                .catch(error => {

                });
            },
 
          },
         created() {
            this.notificationId = this.$route.params.notificationId;
           if((store.state.page_url) && (store.state.page_url === 'Tasklists')) {
             this.selectedComponent = store.state.active_tab;
           }
           var roles = store.state.roles;
           if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
             this.masterAdmin = true;
           }
           if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
             this.admin = true;
           }
           this.fetchCategoryOptions();
           this.fetchNotificationDetails();
         }
    }
</script>

<style scoped>
hr {
    border-top: 2px solid #8b8b8b;
    margin: 0px;
}
label {
  color: #242426;
  padding-top: 8px;
}
.btn-blue {
  /* background-color: #dc2227 !important;
  border: 1px solid #dc2227 !important; */
  background-color: #00ACEE !important;
  border: 1px solid #00ACEE !important;
}
.create-btn {
    line-height: 15px;
    font-weight: bold;
    font-size: 13px;
    text-transform: capitalize;
}
.subtask-wrapper {
  font-size: 14px;
  
  margin-bottom: 10px;
  background: none;
  border: 0;
}
.task-wrapper .card {
  border: 0;
}
.subtask-wrapper h4 {
  background-color: #8B8B8B;
  color: #FFF;
  font-size: 14px;
  font-weight: bold;
  padding: 5px 15px;
  margin-bottom: 0;
}
.panel-title a {
    display: block;
    padding: 0;
    margin: 0;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 1px;
    color: #FFF;
    position: relative;
    text-decoration: none;
}

input, select, textarea{
  border: 1px solid #242426;
  border-radius: 0;
}

textarea {
  resize: none;
}
.panel-title a::after, .panel-title a.collapsed::after {
    border: 1px solid transparent;
    color: #FFF;
    content: "-";
    font-family: fontawesome;
    float: right;
    font-size: 25px;
    font-weight: bold;
    left: 0px;
    top: -5px;
    right: 0px;
    text-align: right;
    position: absolute;
    line-height: 25px;
    width: 100%;
    height: 25px;
}
.panel-title a.collapsed::after {
    box-shadow: none;
    color: #FFF;
    content: "+";
    font-size: 25px;
    font-weight: bold;
}
.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  background-color: #FFF;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 2px;
  background-color: #CCC;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #FFF;
}
input:checked + .slider:before {
  background-color: #83E517;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.character-limit {
  border-bottom: 1px solid #242426 !important;
  border-left: 1px solid #242426 !important;
  border-right: 1px solid #242426 !important;
  background-color: #EEEEEE;
  padding: 5px;
}
</style>
<style>
.email-message .ql-editor { height: 270px !important; min-height: 270px !important; overflow: scroll !important; }

.email-message .quillWrapper { background-color: #FFF;  }
.email-message .add-on {
  font-weight: normal;
  font-size: 12px;
  color: #8D8D8D !important;
  cursor: pointer;
  text-align: right;
}
.email-message .quillWrapper .ql-container.ql-snow {
  border: 1px solid #242426 !important;
  border-top: 0;
}
.email-message .quillWrapper .ql-toolbar.ql-snow {
  border-top: 1px solid #242426 !important;
  border-left: 1px solid #242426 !important;
  border-right: 1px solid #242426 !important;
  background-color: #EEEEEE;
}
.email-message .quillWrapper .ql-formats button {
  padding-left: 0 !important;
  width: 22px !important;
}
.email-message .quillWrapper .ql-formats button svg {
  width: 18px !important;
  height: 18px !importa.nt;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected span::before,
#mentee-group-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected.multiselect__option--highlight,
#mentee-group-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: #FFF !important;
}
#mentee-group-wrapper .multiselect__tags {
  border-radius: 0;
  border: 1px solid #242426 !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/admin/edit_notification_manager.vue